// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"473":"17702789","710":"17702789"}[chunkId] + ".chunk.css";
};